import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { getCurrentLocale } from 'helpers/i18n';
import { localizePrivacyStatementLink, localizeHelpLink } from 'helpers/Localization';
import { media } from 'helpers/MediaHelper';

import { MdHelp as Help } from 'react-icons/md';

import SettingsPopover from './SettingsPopover';
import './NavBar.css';

import LandlordLogo from 'components/shared/LandlordLogo';
import SocialMediaLinks from 'components/ui/SocialMediaLinks';
import Button from '@material-ui/core/Button';

import { colors } from 'helpers/ColorHelper';

const SocialIconsContainer = styled.div`
  padding: 8px;
  display: table-cell;
  padding-right: 30px;
  ${media.mobile`
    display: none;
  `};
`;

class NavBar extends Component {
  render() {
    const style = {
      menu_icon: {
        fontSize: '30px',
        marginRight: '15px',
      },
      button: { padding: '8px', minWidth: '40px', color: colors.MENU_ITEM_GRAY },
    };

    const { privacyStatementLink, helpDocuments } = this.props;
    const language = getCurrentLocale();

    return (
      <div className="nav-bar" style={{ position: 'fixed', width: '100%' }}>
        <header
          className="global-header-view"
          style={{
            boxShadow:
              '0px 1px 3px 0px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.12)',
          }}
        >
          <nav>
            <div
              className="navigation-canvas"
              style={{
                margin: 'auto',
                backgroundColor: 'white',
                padding: '5px 15px',
                borderBottom: 'none',
                height: '65px',
              }}
            >
              <div
                className="row"
                style={{ width: '116px', float: 'left', marginTop: '-1px', marginLeft: '8px' }}
              >
                <LandlordLogo maxWidth="116px" height="46px" textHeight="30px" textAlign="left" />
              </div>
              <div className="row" style={{ float: 'right' }}>
                {this.props.links && (
                  <SocialIconsContainer>
                    <SocialMediaLinks links={this.props.links} />
                  </SocialIconsContainer>
                )}
                <span className="global-header-item settings">
                  <SettingsPopover
                    logUserOut={this.props.logUserOut}
                    userType={this.props.userType}
                    privacyStatementLink={localizePrivacyStatementLink(
                      privacyStatementLink,
                      language
                    )}
                  />
                  <div className="flyout-tip" />
                </span>
                {this.props.showHelp && (
                  <span className="global-header-item help">
                    <a
                      href={localizeHelpLink(helpDocuments, language, 'residentPortal')}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Button aria-label="help" style={style.button}>
                        <Help size={25} style={{ color: colors.BLUE }} />
                      </Button>
                    </a>
                  </span>
                )}
              </div>
            </div>
          </nav>
        </header>
      </div>
    );
  }
}

export default connect((store) => ({
  showHelp: store.userTypes.showHelp,
  links: store.tenantProfile.buildingCommunity.social_media_links,
}))(NavBar);
